export const DEFAULT_BACKGROUND_COLOR = '#16D4E6';
export const FLOATING_LABEL_FONT_SIZE = 12;
